export default {
  init() {
      $.ajax ({
        type: "GET",
        url: '?get_contacts',
        dataType: 'json',
        async: true,
        success: function (res){
            if(res.render) {
                 if(res.cords.lat.length && res.cords.lng.length) {
                    var ico = (res.ico) ? res.ico : null;
                    var position = new google.maps.LatLng(res.cords.lat,res.cords.lng);
                    var mapOptions = { 
                        zoom: 8,
                        center: position,
                        disableDefaultUI: true,
                        draggable: true,
                        scrollwheel: false, 
                        panControl: false,
                        zoomControl: true,
                        mapTypeControl: false,
                    };
                    var map = new google.maps.Map(document.getElementById("map"),mapOptions);
                    var marker = new google.maps.Marker({
                            icon: ico,
                            map: map,
                            position: position,
                    });
					
					var infowindow = new google.maps.InfoWindow({ 
						content: res.address,
						maxWidth: 600,
					});	  		
					google.maps.event.addListener(marker, 'click', function() {
						infowindow.open(map,marker);
					});	
                 }
            }
        },
      });
  },
  finalize() { 

  },
};
  


// WEBPACK FOOTER //
// ./scripts/routes/contact.js